import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as CommonConstants from '../../utils/common.constants';
import { MedicalFileService } from 'src/app/medical-file/medical-care-plan/medical.file.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { SharedService } from 'src/app/utils/shared.service';
import swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { MasterService } from 'src/app/masters/master.service';
import { LoaderService } from 'src/app/common/loader.service';
import { GridApi } from 'ag-grid-community';
import { Parameter } from 'src/app/common/grid-utils/parameter.model';
import { GridNgSelectDataComponent } from 'src/app/common/grid-utils/grid-ng-select-component';
import { CustomDateComponent } from 'src/app/common/grid-utils/custom-date-component.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AddMedicalCarePlanComponent } from 'src/app/medical-file/medical-care-plan/add-medical-care-plan/add-medical-care-plan.component';

@Component({
  selector: 'app-initial-examination',
  templateUrl: './initial-examination.component.html',
  styleUrls: ['./initial-examination.component.scss']
})
export class InitialExaminationComponent implements OnInit {
  defaultColDef = {
    editable: true,
    singleClickEdit: true
  }
  @Input() medFileId;
  medFileForm: FormGroup;
  secondOpinionForm: FormGroup;
  status = [];
  urgency = [];
  medicalFile;
  patientCondition = [];;
  masterValues = [];;
  masterCodes = [];;
  subjectiveSign = [];;
  objectiveSign = [];;
  medSubjectiveSign = [];;
  medObjectiveSign = [];
  medImmediatAction = [];;
  medSecondOpinion = [];
  imActionRowData = [];
  secondOpinionRowData = [];
  imActionDefs;
  actiongridApi: GridApi;
  secondOpinionefs;
  secOpiniongridApi: GridApi;
  frameworkComponents;
  specialities = [];
  subSpecialities = [];
  hyperSpecialities = [];
  countries = [];
  towns = [];
  partnerList = [];
  hospitalList = [];
  specialistList = [];
  submitted = false;
  dropdownSettings: IDropdownSettings;
  modalRef: BsModalRef;
  selectedSubjectiveSigns;
  selectObjectiveSigns;
  ptype = [CommonConstants.PARTNER_HOSPITAL_TYPE, CommonConstants.PARTNER_PRACTITIONER_TYPE];
  PARAM_KEY = [CommonConstants.STATUS, CommonConstants.PATIENT_CONDITION, CommonConstants.MED_URGENCY];
  PARAM__CODE_KEY = [CommonConstants.STATUS, CommonConstants.SUBJECTIVE_SIGN, CommonConstants.OBJECTIVE_SIGN];
  SERVICE_KEYS = [CommonConstants.MED_SUBJECTIVE_SIGN, CommonConstants.MED_OBJECTIVE_SIGN, CommonConstants.MED_ACTION, CommonConstants.MED_SECOND_OPINION];
  constructor(private modal: NgbModal, private fb: FormBuilder, private medicalFileService: MedicalFileService, private masterService: MasterService
    , private toastrService: ToastrService, private sharedService: SharedService, private modalService: BsModalService, private loaderService: LoaderService) {
    this.frameworkComponents = {
      ngSelectEditor: GridNgSelectDataComponent,
      agDateInput: CustomDateComponent
    }
    this.getFormGroup();
    this.getSecOpinionFormGroup();
    this.loadMaster();
    this.loadSecondOpinionMasterData();
  }

  ngOnInit() {
    this.loadMedicalFileDtls();
    this.loadInitialExamination();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'descriptionEn',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      //itemsShowLimit: 3,
      allowSearchFilter: true
    };
  }
  loadMaster() {
    this.masterService.getMastersByParamKey(this.PARAM_KEY).subscribe(response => {
      if (response && response['result']) {
        this.masterValues = response['result'];
        this.patientCondition = this.masterValues.filter(master => master.paramKey === CommonConstants.PATIENT_CONDITION);
        this.status = this.masterValues.filter(master => master.paramKey === CommonConstants.STATUS);
        this.urgency = this.masterValues.filter(master => master.paramKey === CommonConstants.MED_URGENCY);
      }
    });

    //Load master with international codes

    this.masterService.getMastersCodesByParamKey(this.PARAM__CODE_KEY).subscribe(response => {
      if (response && response['result']) {
        this.masterCodes = response['result'];
        this.subjectiveSign = this.masterCodes.filter(master => master.paramKey === CommonConstants.SUBJECTIVE_SIGN);
        this.objectiveSign = this.masterCodes.filter(master => master.paramKey === CommonConstants.OBJECTIVE_SIGN);
      }
    });
  }
  loadInitialExamination() {
    this.medicalFileService.getDetailsByKeys(this.medFileId, this.SERVICE_KEYS).subscribe(response => {
      if (response && response['code'] === 'S0000' && response['result']) {
        setTimeout(() => {
          this.medSubjectiveSign = response['result'][CommonConstants.MED_SUBJECTIVE_SIGN].map(item => ({
            ...item,
            descriptionEn: item.subsiId && item.subsiId != "" ? this.subjectiveSign.find(obj => obj.id === +item.subsiId).descriptionEn : null
          }));
          this.medObjectiveSign = response['result'][CommonConstants.MED_OBJECTIVE_SIGN].map(item => ({
            ...item,
            descriptionEn: item.objsiId && item.objsiId != "" ? this.objectiveSign.find(obj => obj.id === +item.objsiId).descriptionEn : null
          }));
        }, 500);

        this.medSecondOpinion = response['result'][CommonConstants.MED_SECOND_OPINION].map(item => ({
          ...item,
          statusvalue: item.statuCode && item.statuCode != "" ? this.status.find(obj => obj.id === +item.statuCode).value : null,
          urgencyvalue: item.urgcyCode && item.urgcyCode != "" ? this.urgency.find(obj => obj.id === +item.urgcyCode).value : null
        }));
        // this.secondOpinionRowData = this.medSecondOpinion;
        this.medImmediatAction = response['result'][CommonConstants.MED_ACTION].map(item => ({
          ...item,
          statusvalue: item.statuCode && item.statuCode != "" ? this.status.find(obj => obj.id === +item.statuCode).value : null

        }));
        this.imActionRowData = this.medImmediatAction;
      } else {
        swal.fire("Error", response['message'], 'error');
      }
    },
      error => {
        swal.fire("Error", "Error Occured While Fetching Medical File Details", 'error');
      })
  }
  loadMedicalFileDtls() {
    this.medicalFileService.getMedicalFile(this.medFileId).subscribe(response => {
      if (response && response['code'] === 'S0000' && response['result']) {
        this.medicalFile = response['result'];
        this.medFileForm.patchValue({ medfiVaBloodPressure: this.medicalFile.medfiVaBloodPressure, medfiVaTemperature: this.medicalFile.medfiVaTemperature, medfiVaPulse: this.medicalFile.medfiVaPulse, medfiVaExamination: this.medicalFile.medfiVaExamination });
      } else {
        swal.fire("Error", response['message'], 'error');
      }
    },
      error => {
        swal.fire("Error", "Error Occured While Fetching Medical File Details", 'error');
      })
  }
  private getFormGroup() {
    this.medFileForm = this.fb.group({
      'medfiVaBloodPressure': new FormControl(),
      'medfiVaTemperature': new FormControl(),
      'medfiVaPulse': new FormControl(),
      'medfiVaExamination': new FormControl()
    })
  }

  get f() { return this.medFileForm.controls; }
  updateMedicalFile() {
    this.medicalFile["medfiVaBloodPressure"] = this.medFileForm.value.medfiVaBloodPressure;
    this.medicalFile["medfiVaTemperature"] = this.medFileForm.value.medfiVaTemperature;
    this.medicalFile["medfiVaPulse"] = this.medFileForm.value.medfiVaPulse;
    this.medicalFile["medfiVaExamination"] = this.medFileForm.value.medfiVaExamination;
    this.medicalFileService.saveMedFiles(this.medicalFile).subscribe(res => {
      this.loaderService.display(false);
      if (res && res["result"]) {
        let response = res["result"];
        swal.fire("Success", res['message'], 'success');
      }
    }, error => {
      this.loaderService.display(false);
      swal.fire("Error", "Error Occured While Saving Medical File", 'error');
    })
  }
  //Immediat Action
  immediateActionAddModal(immediateAction) {
    this.modal.open(immediateAction, { size: 'lg', windowClass: 'full-width', container: '.page-content' });
    if (!this.imActionDefs) {
      this.getImmediateActionGrid();
    }

  }
  getImmediateActionGrid() {
    //add diagnotic 
    this.imActionDefs = [
      { headerName: 'Limit Date & Time', field: 'medacDtLimit', cellEditor: 'agDateInput' },
      { headerName: 'Condition', field: 'medacVaCondition' },
      { headerName: 'Description', field: 'medacVaDescription' },
      { headerName: 'Duration in Day', field: 'medacNuDurationDay' },
      { headerName: 'Operator', field: 'medacVaOperator' },
      { headerName: 'Then After', field: 'medacVaThenAfter' },
      { headerName: 'statuCode', field: 'statuCode', hide: true },
      {
        headerName: 'Status', field: 'statusvalue', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.status, dataColumn: 'statuCode', model: new Parameter(), objectData: ['id', 'value'] }
      }
    ];
  }
  onGridReadyimAction(params) {
    this.actiongridApi = params.api;
    this.actiongridApi.sizeColumnsToFit();
  }
  addNewAction() {
    const newAction = { medacDtLimit: '', medacVaCondition: '', medacVaDescription: '', medacNuDurationDay: '', medacVaOperator: '', medacVaThenAfter: '', statuCode: '' };
    this.imActionRowData.push(newAction);
    this.actiongridApi.setRowData(this.imActionRowData);
  }
  onImActionRowSelect(immediateAction) {
    this.getImmediateActionGrid();
    this.modal.open(immediateAction, { size: 'lg', windowClass: 'full-width', container: '.page-content' });
    this.imActionRowData = this.medImmediatAction;
  }

  //Second Opinion
  secondOpinionsAddModal(secondOpinion) {
    this.secondOpinionForm.reset();
    this.modal.open(secondOpinion, { size: 'xl', container: '.page-content' });

  }
  /* getSecondOpinionGrid() {
    //add diagnotic 
    this.secondOpinionefs = [
      { headerName: 'Limit Date & Time', field: 'medacDtLimit', cellEditor: 'agDateInput' },
      { headerName: 'Condition', field: 'medacVaCondition' },
      { headerName: 'Description', field: 'medacVaDescription' },
      { headerName: 'Duration in Day', field: 'medacNuDurationDay'},
      { headerName: 'Operator', field: 'medacVaOperator' },
      { headerName: 'Then After', field: 'medacVaThenAfter'},
      { headerName: 'statuCode', field: 'statuCode' ,hide:true}, 
      { headerName: 'statuCode', field: 'statuCode' ,hide:true},
      {
        headerName: 'Speciality', field: 'statusvalue', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.status, dataColumn: 'statuCode', model: new Parameter(), objectData: ['id', 'value'] }
      }
    ];
  }
  onGridReadySecOpinion(params) {
    this.secOpiniongridApi = params.api;
  }
  addNewSecOpinion() {
    const newFHist = { medacDtLimit: '', medacVaCondition: '', medacVaDescription: '', medacNuDurationDay: '' ,medacVaOperator: '', medacVaThenAfter: '', statuCode: ''};
    this.secondOpinionRowData.push(newFHist);
    this.actiongridApi.setRowData(this.secondOpinionRowData);
  }
  onSecondOpinionRowSelect(secondOpinion) {
    this.getSecondOpinionGrid();
    this.modal.open(secondOpinion, { size: 'lg',  windowClass: 'full-width',container: '.page-content' });
    this.secondOpinionRowData = this.medSecondOpinion;
   }*/

  private getSecOpinionFormGroup() {
    this.secondOpinionForm = this.fb.group({
      'medsoId': [],
      'hospiId': new FormControl(),
      'hsptyId': new FormControl(),
      'medfiId': [],
      'medsoVaComment': ['', Validators.required],
      'medsoVaOpinionFor': ['', Validators.required],
      'spltyId': new FormControl(),
      'ssptyId': new FormControl(),
      'statuCode': ['', Validators.required],
      'urgcyCode': new FormControl(),
      'cotryId': new FormControl(),
      'townId': new FormControl(),
      'prtieId': new FormControl(),
    })
  }
  get secOpinion() { return this.secondOpinionForm.controls; }
  onSecondOpinionRowSelect(event, secondOpinion) {
    this.patchSecondOpinion(event.data);
    this.modal.open(secondOpinion, { size: 'xl', container: '.page-content' });
  }
  loadSecondOpinionMasterData() {
    this.masterService.getSpecialities().subscribe(response => {
      if (response && response['result']) {
        this.specialities = response['result'];
      }
    })
    this.masterService.getSubSpecialities().subscribe(response => {
      if (response && response['result']) {
        this.subSpecialities = response['result'];
      }
      this.masterService.getHyperSpecialities().subscribe(response => {
        if (response && response['result']) {
          this.hyperSpecialities = response['result'];
        }
      })
    })
    this.masterService.getCountry().subscribe(response => {
      if (response && response['result']) {
        this.countries = response['result'];

      }
    })
    this.masterService.getTown().subscribe(response => {
      if (response && response['result']) {
        this.towns = response['result'];
      }
    })

    //Hospital and Specailist
    this.masterService.getPartnersByPartnerType(this.ptype);
    this.masterService.partnerList.subscribe(value => {
      this.partnerList = value;
      this.filterPartnerTypes();
    });
  }
  filterPartnerTypes() {
    if (!this.partnerList) {
      this.masterService.getPartnersByPartnerType(this.ptype);
      this.masterService.partnerList.subscribe(value => {
        this.partnerList = value;
        this.setPartners();
      })
    } else {
      this.setPartners();
    }

  }

  setPartners() {
    this.hospitalList = this.partnerList.filter(item => item.partnertypeid === CommonConstants.PARTNER_HOSPITAL_TYPE);
    this.specialistList = this.partnerList.filter(item => item.partnertypeid === CommonConstants.PARTNER_PRACTITIONER_TYPE);
  }
  saveImAction() {
    this.imActionRowData = this.imActionRowData.map(item => ({
      ...item,
      'medfiId': this.medFileId
    }));
    this.imActionRowData = this.imActionRowData.filter(item => item.edited && item.edited === true);
    this.medicalFileService.saveImmediateAction(this.imActionRowData).subscribe(res => {
      if (res && res["result"]) {
        this.toastrService.success("Saved Succesffully");
        for (let item of res["result"]) {
          item["statusvalue"] = item.statuCode && item.statuCode != "" ? this.status.find(obj => obj.id === +item.statuCode).value : null
          this.medImmediatAction.push(item);
        }
        this.medImmediatAction = Object.values(this.medImmediatAction.reduce((acc, c) => (acc[c.medcaId] = c, acc), {}));
        this.medImmediatAction = [...this.medImmediatAction];
        this.modal.dismissAll();
      }
    }, error => {
      this.loaderService.display(false);
      swal.fire("Error", "Error Occured While Saving Medical Action", 'error');
    })
  }
  saveSecondOpinion() {
    this.submitted = true;
    if (this.secondOpinionForm.invalid) {
      return;
    }
    this.secondOpinionForm.value.medfiId = this.medFileId;
    let jsonData = [];
    jsonData.push(this.secondOpinionForm.value);
    this.medicalFileService.saveSecondOpinion(jsonData).subscribe(res => {
      this.loaderService.display(false);
      if (res && res["result"]) {
        let response = res["result"][0];
        swal.fire("Success", res['message'], 'success');
        response["statusvalue"] = response.statuCode && response.statuCode != "" ? this.status.find(obj => obj.id === +response.statuCode).value : null;
        response["urgencyvalue"] = response.urgcyCode && response.urgcyCode != "" ? this.urgency.find(obj => obj.id === +response.urgcyCode).value : null;
        this.medSecondOpinion.push(response);
        this.medSecondOpinion = Object.values(this.medSecondOpinion.reduce((acc, c) => (acc[c.medsoId] = c, acc), {}));
        this.medSecondOpinion = [...this.medSecondOpinion];
        this.modal.dismissAll();
      }
    }, error => {
      this.loaderService.display(false);
      swal.fire("Error", "Error Occured While Saving Second Opinion", 'error');
    })
  }
  onCellValueChanged(params: any) {
    if (!params.data.edited && params.newValue != params.oldValue) {
      params.data["edited"] = true;
    }
  }
  patchSecondOpinion(secondOpinion) {
    let opinion = this.medSecondOpinion.filter(item => item.medsoId === secondOpinion.medsoId);
    Object.keys(opinion[0]).forEach(name => {
      if (this.secOpinion[name]) {
        if (name === "statuCode" || name === "urgcyCode") {
          this.secOpinion[name].patchValue(+opinion[0][name]);
        } else {
          this.secOpinion[name].patchValue(opinion[0][name]);
        }
      }
    });
  }
  resetForm() {
    this.secondOpinionForm.reset();
  }
  carePlanAddModal() {
    this.modalRef = this.modalService.show(AddMedicalCarePlanComponent, { class: 'modal-xl' });
    this.modalRef.content.modalreference = this.modalRef;
    this.modalRef.content.medFileId = this.medFileId;
  }
  saveObjectiveModal() {
    let jsonData = this.selectObjectiveSigns.map(item => ({
      objsiId: item.id,
      medfiId: this.medFileId
    }));
    this.loaderService.display(true);
    this.medicalFileService.saveObjectiveSign(jsonData).subscribe(res => {
      if (res['code'] === "0") {
        this.loaderService.display(false);
        for (let sub of this.selectObjectiveSigns) {
          this.medObjectiveSign.push(sub);
        }
        this.toastrService.success('Objective Sign Added Succesfully');
        this.selectObjectiveSigns = [];
      }
      else {
        this.loaderService.display(false);
        this.toastrService.error('Error While Adding Subjective Sign');
      }
    })
  }
  saveSubjectiveModal() {
    let jsonData = this.selectedSubjectiveSigns.map(item => ({
      subsiId: item.id,
      medfiId: this.medFileId
    }));
    this.loaderService.display(true);
    this.medicalFileService.saveSubjectiveSign(jsonData).subscribe(res => {
      if (res['code'] === "0") {
        this.loaderService.display(false);
        for (let sub of this.selectedSubjectiveSigns) {
          this.medSubjectiveSign.push(sub);
        }
        this.toastrService.success('Subjective Sign Added Succesfully');
        this.selectedSubjectiveSigns = [];
      }
      else {
        this.loaderService.display(false);
        this.toastrService.error('Error While Adding Subjective Sign');
      }
    })
  }
  loadDataToCarePlaList(event){
    console.log(+JSON.stringify(event));
  }
}
